import { render, staticRenderFns } from "./InsuranceCompaniesTableCollapse.vue?vue&type=template&id=6dc92f5c&"
import script from "./InsuranceCompaniesTableCollapse.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompaniesTableCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports